module.exports = __webpack_public_path__ + "img/bg_video2.46f85b68.png";